import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { defaultColors, useHabits } from "@/context/SupabaseHabitContext";
import ColorPicker from "./ColorPicker";
import { HabitColor } from "@/context/SupabaseHabitContext";
import { toast } from "sonner";
import { Plus } from "lucide-react";

interface AddHabitFormProps {
  onClose?: () => void;
  onUpgradeRequired?: () => void;
}

export default function AddHabitForm({ onClose, onUpgradeRequired }: AddHabitFormProps) {
  const [name, setName] = useState("");
  const [selectedColor, setSelectedColor] = useState<HabitColor>(defaultColors);
  const { addHabit } = useHabits();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!name.trim()) {
      toast.error("Please enter a habit name");
      return;
    }
    
    addHabit(name.trim(), selectedColor);
    toast.success(`Habit "${name}" created`);
    
    // Clear the form
    setName("");
    setSelectedColor(defaultColors);
    
    // Close the form if needed
    if (onClose) {
      onClose();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <Input
          type="text"
          placeholder="New habit name..."
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full"
          maxLength={50}
        />
      </div>
      
      <div>
        <p className="text-sm font-medium mb-1">Choose a color (colour code to help stack your habits)</p>
        <ColorPicker 
          selectedColor={selectedColor} 
          onSelectColor={setSelectedColor} 
          onUpgradeRequired={onUpgradeRequired}
        />
      </div>
      
      <Button type="submit" className="w-full mt-4">
        <Plus size={16} className="mr-1" /> Add Habit
      </Button>
    </form>
  );
}
